import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Loan.css";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const monthNames = [
  { name: "January", value: 1 },
  { name: "February", value: 2 },
  { name: "March", value: 3 },
  { name: "April", value: 4 },
  { name: "May", value: 5 },
  { name: "June", value: 6 },
  { name: "July", value: 7 },
  { name: "August", value: 8 },
  { name: "September", value: 9 },
  { name: "October", value: 10 },
  { name: "November", value: 11 },
  { name: "December", value: 12 },
];

const LoanExcelReport = ({ formatPrice, loan, onClose, companyId }) => {
  const [formData, setFormData] = useState({
    year: new Date().getFullYear().toString(), // Default to current year
    month: "", // month will be a number (1–12)
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { year, month } = formData;

    if (!month || month < 1 || month > 12) {
      toast.error("Please select a valid month");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.get(
        `/loan/report/excel/${companyId}?month=${month}&year=${year}`
      );
      const loanData = response.data.data;

      if (loanData.length === 0) {
        toast.info("No loan data available for this period.");
      } else {
        toast.success("Report generated successfully");
        handleExport(loanData);
        onClose();
      }
    } catch (error) {
      // console.error("Excel report fetch error", error);
      toast.error(
        error?.response?.data?.message || "Failed to fetch Excel report."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleExport = (loanData) => {
    const sheetData = [];
    const merges = [];

    const headers = [
      "Sl No",
      "Company Name",
      "Company Code",
      "Report Date",
      "Employee No",
      "Employee Name",      
      "Total Loan Amount ($)",
      "Current Month Payments ($)",
      "Total Paid Before ($)",
      "Balance Amount ($)",
    ];
    sheetData.push(headers);

    for (let col = 0; col < headers.length; col++) {
      merges.push({ s: { r: 0, c: col }, e: { r: 0, c: col } });
    }

   loanData.forEach((item, index) => {
  const row = [
    index + 1,
    item.companyName || "",
    item.companyCode || "",
    item.reportDate || "",
    item.employeeNo || "",
    item.employeeName || "",  
    Number(item.totalLoanAmount || 0),       // <- raw number
    Number(item.currentMonthPaid || 0),      // <- raw number
    Number(item.totalPaidBefore || 0),       // <- raw number
    Number(item.balanceAmount || 0),         // <- raw number
  ];

  sheetData.push(row);
});


    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    worksheet["!merges"] = merges;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    const monthName = monthNames.find((m) => m.value === parseInt(formData.month))?.name;
    const filename = `loan_report_${formData.year}_${monthName}.xlsx`;
    saveAs(dataBlob, filename);
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content loan_model">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">Excel Report Form</h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <form onSubmit={handleSubmit}>
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Get Excel Report
                  </h5>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Year</label>
                      <input
                        type="number"
                        className="form-control"
                        name="year"
                        value={formData.year}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Select Month</label>
                      <select
                        className="form-select"
                        name="month"
                        value={formData.month}
                        onChange={handleChange}
                        required
                      >
                        <option value="">-- Select Month --</option>
                        {monthNames.map((month) => (
                          <option key={month.value} value={month.value}>
                            {month.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 text-center">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading ? "Processing..." : "Download Excel"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanExcelReport;
